import { CommonModule } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse, ProperHttpParamEncoder } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { MoveCargoRequest } from 'app/generated/backend/shipment/api/move-cargo-request';
import { MoveCargoResponse } from 'app/generated/backend/shipment/api/move-cargo-response';
import { ShipmentDetailModel } from 'app/generated/backend/shipment/api/shipment-detail-model';

@Injectable()
export class MoveCargoHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		shipmentNumber: string,
		partyId: number
	): Observable<JsonResourceResponse<MoveCargoResponse[]>> {
		let params = new HttpParams({ encoder: new ProperHttpParamEncoder() });
		if (shipmentNumber!==null && shipmentNumber!==undefined) {
			params = params.set('shipmentNumber', shipmentNumber);
		}
		if (partyId!==null && partyId!==undefined) {
			params = params.set('partyId', partyId.toString());
		}
		return this.http.get<JsonResourceResponse<MoveCargoResponse[]>>('api/v1/shipment/moveCargo', { params }).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	post(
		request: MoveCargoRequest
	): Observable<JsonResourceResponse<ShipmentDetailModel>> {
		return this.http.post<JsonResourceResponse<ShipmentDetailModel>>('api/v1/shipment/moveCargo', request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		MoveCargoHandlerService
	]
})
export class MoveCargoHandlerModule { }
